import api from "../config/api";
import { Sprint } from "../types/Sprint";

const API_URL = "/sprint";

export const getSprints = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getSprintById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const getSprintByPojectId = (projectId: number) =>
  api.get(`${API_URL}/?projectId=${projectId}`);

export const createSprint = (data: Sprint) => api.post(`${API_URL}/`, data);

export const updateSprint = (id: number, data: Sprint) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteSprint = (id: number) => api.delete(`${API_URL}/?id=${id}`);
